import { getFunctions, httpsCallable } from 'firebase/functions';
import app from './config';

const functions = getFunctions(app, 'europe-west1');

export default functions;

export const callFunction = (name, options) => httpsCallable(functions, name, options);
